import { decodeFunctionData } from 'viem'

import type { WireUserOperation } from './wire-userop'

export const executeAbi = [
  {
    type: 'function',
    name: 'execute',
    stateMutability: 'payable',
    inputs: [
      { name: 'target', type: 'address' },
      { name: 'value', type: 'uint256' },
      { name: 'data', type: 'bytes' }
    ],
    outputs: []
  }
] as const

export const executeBatchAbi = [
  {
    type: 'function',
    name: 'executeBatch',
    stateMutability: 'payable',
    inputs: [
      { name: 'dest', type: 'address[]' },
      { name: 'value', type: 'uint256[]' },
      { name: 'func', type: 'bytes[]' }
    ],
    outputs: []
  }
] as const

const EXECUTE_SELECTOR = '0xb61d27f6'
const EXECUTE_BATCH_SELECTOR = '0x47e1da2a'

export interface DecodedCall {
  to: `0x${string}`
  value: string
  data: `0x${string}`
}

export type DecodedUserOpCalls =
  | { kind: 'calls'; calls: DecodedCall[] }
  | { kind: 'deploy' }
  | { kind: 'unknown'; selector: string }

export function decodeUserOpCalls(userOp: Pick<WireUserOperation, 'callData'> & Partial<WireUserOperation>): DecodedUserOpCalls {
  const callData = (userOp.callData || '0x').toLowerCase() as `0x${string}`
  if (callData === '0x') {
    return { kind: 'deploy' }
  }
  const selector = callData.slice(0, 10)
  try {
    if (selector === EXECUTE_SELECTOR) {
      const decoded = decodeFunctionData({ abi: executeAbi, data: callData })
      const [to, value, data] = decoded.args
      return { kind: 'calls', calls: [{ to: to.toLowerCase() as `0x${string}`, value: value.toString(), data }] }
    }
    if (selector === EXECUTE_BATCH_SELECTOR) {
      const decoded = decodeFunctionData({ abi: executeBatchAbi, data: callData })
      const [targets, values, datas] = decoded.args
      if (targets.length === 0 || targets.length !== values.length || targets.length !== datas.length) {
        return { kind: 'unknown', selector }
      }
      return {
        kind: 'calls',
        calls: targets.map((to, index) => ({ to: to.toLowerCase() as `0x${string}`, value: values[index].toString(), data: datas[index] }))
      }
    }
  } catch {
    return { kind: 'unknown', selector }
  }
  return { kind: 'unknown', selector }
}
